import React, { useContext, useEffect, useRef, useState } from "react";
import { fmDataContext } from "../../Context/FmData";
import Pagination from "../Pagination/Pagination";
import { Link } from "react-router-dom";
import LoadingScreen from "../LoadingScreen/LoadingScreen";
import HomeSlideRow from "./HomeSlideRow";
import LoadingCircle from "../LoadingCircle/LoadingCircle";
import { fmHomeSlidesContext } from "../../Context/HomeSlidesContext";
import userCan from "../../helpers/userCan";
import { toast } from "react-toastify";
import HomeSlidesFilration from "./HomeSlidesFilration";

const HomeSlides = () => {
  const isCalledRef = useRef(false);

  let { baseUrl, navigate, getData } = useContext(fmDataContext);

  let [homeSlides, setHomeSlides] = useState({});

  let [isGetHomeSlidesLoading, setIsGetHomeSlidesLoading] = useState(true);

  let [isPaginateLoading, setIsPaginateLoading] = useState(false);

  let [pageNum, setPageNum] = useState(1);

  let perPage = 20;
  let orderBy = "id";
  let orderType = "desc";

  let { homeSlideMsg, setHomeSlideMsg, filtrationDetails, isFiltrationLoading, setFiltrationDetails } = useContext(fmHomeSlidesContext);

  const getHomeSlides = (reqMethod, pathName, params, setLoading = setIsGetHomeSlidesLoading, message = null) => {
    getData(reqMethod, pathName, params, setLoading)
      .then((response) => {
        // ------------------ REMOVE BEFORE PRODUCTION --------------------------------
        // if (response.data.data) {
        //   response.data.data.forEach((homeSlide) => {
        //     if (homeSlide.slide_image.includes("via.placeholder.com")) {
        //       homeSlide.slide_image = homeSlide.slide_image.replace("http://127.0.0.1:8000/storage/", "");
        //     }
        //   });
        // }
        // ------------------ REMOVE BEFORE PRODUCTION --------------------------------
        setHomeSlides(response.data);
        setLoading(false);

        if (homeSlideMsg.length > 0) {
          toast(homeSlideMsg, {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            progressStyle: { backgroundColor: "#fdb915" },
            closeOnClick: true,
            pauseOnHover: false,
            draggable: true,
            progress: undefined,
            theme: "dark",
            onClose: () => setHomeSlideMsg(""),
          });
        }

        if (message) {
          toast(message, {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            progressStyle: { backgroundColor: "#fdb915" },
            closeOnClick: true,
            pauseOnHover: false,
            draggable: true,
            progress: undefined,
            theme: "dark",
          });
        }
      })
      .catch((error) => {
        navigate("/not-found");
      });
  };

  useEffect(() => {
    if (!isCalledRef.current) {
      getHomeSlides(
        "GET",
        `${baseUrl}fm-home-carousel-slides`,
        {
          page_num: pageNum,
          per_page: perPage,
          order_type: orderType,
          order_by: orderBy,
        },
        setIsGetHomeSlidesLoading
      );
    }

    return () => {
      isCalledRef.current = true;
      setFiltrationDetails({
        search_query: "",
        only_trashed: 0,
      });
    };
  }, []);

  return (
    <>
      <div className="container">
        <div className={`${!isGetHomeSlidesLoading ? "min-vh-100" : ""}`}>
          <div className="mb-2 mb-sm-5">
            <div className="d-flex flex-wrap align-items-center justify-content-between mb-3 mt-3">
              <h1 className="fu-text-white fu-text-3-rem fu-text-3-rem-md fu-text-md-2-rem fu-text-sm-2-rem fu-text-1-8-rem-xs fu-text-18-px-xxs fu-text-16-px-xxs fu-fw-800 mb-0">HOME SLIDES</h1>
              {userCan("fm_home_carousel_slide_create") ? (
                <div className="me-3">
                  <Link to="/fm-home-slides/create" className="fu-btn fu-btn-gray">
                    <span className="btn-bg"></span>
                    Create New
                  </Link>
                </div>
              ) : (
                ""
              )}
            </div>
            {/* ----------------------------------------------------- */}
            <div className="mt-4">
              <HomeSlidesFilration getHomeSlides={getHomeSlides} perPage={perPage} orderBy={orderBy} orderType={orderType} />
            </div>
            {/* ----------------------------------------------------- */}
          </div>
          {!isGetHomeSlidesLoading ? (
            <>
              <div className="row py-3 d-none d-xxl-flex table-heading-brdr">
                <div className="col-md-1">
                  <h3 className="h6 mb-0 fu-text-white">#ID</h3>
                </div>
                <div className="col-md-4">
                  <h3 className="h6 mb-0 fu-text-white">KEY</h3>
                </div>
                <div className="col-md-3">
                  <h3 className="h6 mb-0 fu-text-white">SLIDE TITLE</h3>
                </div>
                <div className="col-md-4">
                  <h3 className="h6 mb-0 fu-text-white">OPERATIONS</h3>
                </div>
              </div>
              <div className="table-heading-brdr mt-4 mt-sm-0 d-xxl-none"></div>
              {isPaginateLoading ? (
                <div className="d-flex justify-content-center mt-5">
                  <div className="position-relative mt-5">
                    <LoadingCircle circleCont={85} icon={80} loader={85} dot={85} />
                  </div>
                </div>
              ) : (
                <>
                  {homeSlides.data && homeSlides.data.length > 0 ? (
                    homeSlides.data.map((homeSlide, index) => <HomeSlideRow key={index} meta={homeSlides.meta} homeSlide={homeSlide} index={index} getHomeSlides={getHomeSlides} perPage={perPage} pageNum={pageNum} orderBy={orderBy} orderType={orderType} />)
                  ) : homeSlides.data && homeSlides.data.length === 0 && filtrationDetails.search_query === "" && filtrationDetails.only_trashed === 0 && !isFiltrationLoading ? (
                    <div className="d-flex flex-column justify-content-center align-items-center mt-5 pt-5 item-msg">
                      <div>
                        <h2 className="fu-text-3-rem fu-text-yellow">
                          <i className="bi bi-database-add"></i>
                        </h2>
                      </div>
                      <div>
                        <h3 className="h5 fu-text-light-gray">
                          There Are No Home Slides
                          {userCan("fm_home_carousel_slide_create") ? (
                            <>
                              ,
                              <Link to="/fm-home-slides/create" className="link-dashed ms-2">
                                Create New
                              </Link>
                            </>
                          ) : (
                            ""
                          )}
                        </h3>
                      </div>
                    </div>
                  ) : !isFiltrationLoading ? (
                    <div className="d-flex flex-column justify-content-center align-items-center mt-5 pt-5 item-msg">
                      <div>
                        <h2 className="fu-text-3-rem fu-text-yellow">
                          <i className="bi bi-search"></i>
                        </h2>
                      </div>
                      <div>
                        <h3 className="h5 fu-text-light-gray">There are no slides matching your search</h3>
                      </div>
                    </div>
                  ) : (
                    ""
                  )}
                  <div className="mt-5">{homeSlides ? homeSlides.meta && homeSlides.meta.last_page !== 1 ? <Pagination pages={homeSlides.meta.links} pagination={homeSlides.meta} getItems={getHomeSlides} pathName={"fm-home-carousel-slides"} filtrationDetails={filtrationDetails} setIsPaginateLoading={setIsPaginateLoading} setPageNum={setPageNum} per_page={perPage} order_by={orderBy} order_type={orderType} /> : "" : ""}</div>
                </>
              )}
            </>
          ) : (
            <LoadingScreen />
          )}
        </div>
      </div>
    </>
  );
};

export default HomeSlides;
